import Axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import "../style/gallery.scss";
import "../style/Page.scss";

var token = sessionStorage.getItem("token");

const Gallery = () => {
  const [data, setData] = useState({
    name: "",
    image: "",
  });

  const [users, setUsers] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);

  const handleChange = (name) => (e) => {
    const value = name === "image" ? e.target.files[0] : e.target.value;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      token = sessionStorage.getItem("token");
      let formData = new FormData();
      formData.append("image", data.image);

      const res = await Axios.post(
        "https://unesco-backend.vercel.app/gallery",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      if (res.ok) {
        setData({ name: "", image: "" });
        setUpdate(true);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      const res = await fetch(`https://unesco-backend.vercel.app/gallery`);
      const data = await res.json();
      setUsers(data.reverse());
    };
    fetchUsers();
    setUpdate(false);
    setLoading(false);
  }, [users]);

  const handleDelete = async (id) => {
    try {
      const res = await Axios.delete(
        `https://unesco-backend.vercel.app/gallery/${id}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      if (res.ok) {
        const updatedUsers = users.filter((user) => user._id !== id);
        setUsers(updatedUsers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="galleryContainer Page">
      <LoadingScreen
        loading={loading}
        bgColor="#ffffff"
        spinnerColor="#01471B"
        textColor="#01471B"
        logoSrc={
          "https://res.cloudinary.com/unesco-admin/image/upload/v1645289463/image003-removebg-preview_dkzzc8.png"
        }
        text="Adding Image"
      ></LoadingScreen>

      <h1 className="heading">Add to Gallery</h1>
      <div className="addPhoto">
        <div className="mb-3">
          <input
            className="form-control"
            type="file"
            accept="image/*"
            name="image"
            onChange={handleChange("image")}
          />
        </div>
        <div className="text-center">
          <button className="btn btn-primary" onClick={handleSubmit}>
            Add
          </button>
        </div>
      </div>

      <div className="row">
        {users?.map((user) => (
          <div className="col-md-3 card" key={user._id}>
            <img src={user.avatar} alt="" width={"100%"} height={200} />
            <div className="p-2">
              <h3>{user.name}</h3>
              <div className="d-flex justify-content-between align-items-center">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(user._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
